import type { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";
import { LessonLibraryCard } from "../teacher/LessonLibraryCard";
import { LessonLinkedStandardsBadge } from "../teacher/LessonLinkedStandardsBadge";
import { DEMO_LIBRARY_LESSONS, type DemoLibraryLesson } from "./demoData";

function publishedBadge() {
  return (
    <span className="teacher-pill teacher-pill--published-badge">
      <FontAwesomeIcon icon={faGlobe} fixedWidth aria-hidden />
      Published
    </span>
  );
}

function draftBadge() {
  return (
    <span className="teacher-pill teacher-pill--draft-badge">
      <FontAwesomeIcon icon={faWandMagicSparkles} fixedWidth aria-hidden />
      Draft
    </span>
  );
}

function lessonOverlay(lesson: DemoLibraryLesson) {
  const pills: ReactNode[] = [];
  if (lesson.communityPublishStatus === "approved") pills.push(publishedBadge());
  else if (lesson.isDraft) pills.push(draftBadge());

  const standards =
    lesson.linkedStandards && lesson.linkedStandards.length > 0 ? (
      <LessonLinkedStandardsBadge standards={lesson.linkedStandards} variant="on-card" />
    ) : null;

  if (pills.length === 0 && !standards) return undefined;

  return (
    <>
      {pills}
      {standards}
    </>
  );
}

/** Read-only grid of real lesson cards, fed with demo lessons. */
export default function LibraryShowcase() {
  return (
    <div className="teacher-lesson-grid landing-library-grid" aria-label="Example lesson library">
      {DEMO_LIBRARY_LESSONS.map((lesson) => (
        <LessonLibraryCard key={lesson.id} lesson={lesson} showcase overlay={lessonOverlay(lesson)} />
      ))}
    </div>
  );
}
